import React, { useState } from "react";
import "./Contact.css";

function Contact() {
  const serviceOptions = [
    "Logo design",
    "Business card design",
    "Poster / Flyer",
    "Website design",
    "Website maintenance",
    "Social media marketing",
    "SEO",
    "Email marketing",
    "Paid ads (PPC)",
    "Content writing",
    "Photography/Video",
  ];

  const countryCodes = ["+1", "+44", "+61", "+81", "+91"];

  const [fullName, setFullName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [phoneCode, setPhoneCode] = useState("+1");
  const [phone, setPhone] = useState("");
  const [service, setService] = useState("");
  const [message, setMessage] = useState("");
  const [agree, setAgree] = useState(true);

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!isValidEmail(email)) {
      setStatus("Please enter a valid email address, like name@example.com.");
      return;
    }

    setLoading(true);
    setStatus("Sending…");

    try {
      const API_BASE_URL =
        window.location.hostname === "localhost"
          ? "http://localhost:5000"
          : "https://shynegraphics-server.onrender.com";

      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: fullName,
          company,
          email,
          phone: phone ? `${phoneCode} ${phone}` : "",
          service,
          message,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus("Thanks! Your proposal request was sent.");
        setFullName("");
        setCompany("");
        setEmail("");
        setPhone("");
        setService("");
        setMessage("");
      } else {
        setStatus(data.error || "Hmm, something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setStatus("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contactPro">
      <div className="contactPro__inner">
        <header className="contactPro__head">
          <span className="contactPro__eyebrow">Get a quote</span>
          <h1>Send my free proposal</h1>
          <p>
            Tell us a bit about your business and what you need. We’ll reply
            with a tailored plan.
          </p>
        </header>

        <div className="contactPro__grid">
          <form className="contactPro__form" onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label>Full Name *</label>
              <input
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                placeholder="Your full name"
              />
            </div>

            <div className="field">
              <label>Email Address *</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
              />
            </div>

            <div className="field phone">
              <label>Phone Number</label>
              <div className="phoneWrap">
                <div className="selectWrap selectWrap--phone">
                  <select
                    aria-label="Country code"
                    value={phoneCode}
                    onChange={(e) => setPhoneCode(e.target.value)}
                  >
                    {countryCodes.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                  <span className="selectIcon" aria-hidden="true">▾</span>
                </div>

                <input
                  type="tel"
                  inputMode="tel"
                  placeholder="555-123-4567"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Company / Organization Name</label>
              <input
                value={company}
                onChange={(e) => setCompany(e.target.value)}
                placeholder="Your company name"
              />
            </div>

            <div className="field">
              <label>Service *</label>
              <div className="selectWrap">
                <select
                  required
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                >
                  <option value="">Select…</option>
                  {serviceOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
                <span className="selectIcon" aria-hidden="true">▾</span>
              </div>
            </div>

            <div className="field">
              <label>Tell us about your business *</label>
              <textarea
                rows={6}
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Goals, audience, current challenges, and any must-haves…"
              />
            </div>

            <label className="agree">
              <input
                type="checkbox"
                checked={agree}
                onChange={() => setAgree(!agree)}
              />
              <span>I agree to be contacted about my request.</span>
            </label>

            <button
              type="submit"
              className="contactPro__cta"
              disabled={
                !fullName ||
                !email ||
                !message ||
                !agree ||
                !service ||
                loading
              }
            >
              {loading ? "Sending…" : "Send my free proposal"}
            </button>

            {status && <p className="status">{status}</p>}
          </form>

          <aside className="contactPro__aside">
            <div className="asideCard">
              <h3>Let’s get started</h3>
              <p>
                Take the first step and tell us your goals. We’ll reply fast
                with a clear, honest proposal.
              </p>

              <div className="steps">
                <div className="step">
                  <span className="stepIcon" aria-hidden="true">①</span>
                  <div>
                    <strong>We review your request</strong>
                    <p className="muted">Usually within 1 business day.</p>
                  </div>
                </div>

                <div className="step">
                  <span className="stepIcon" aria-hidden="true">②</span>
                  <div>
                    <strong>We send your proposal</strong>
                    <p className="muted">Scope, timeline, and next steps.</p>
                  </div>
                </div>

                <div className="step">
                  <span className="stepIcon" aria-hidden="true">③</span>
                  <div>
                    <strong>Quick follow-up</strong>
                    <p className="muted">If we need any missing details.</p>
                  </div>
                </div>
              </div>

              <div className="company">
                <p><strong>Shyne Graphics Corp.</strong></p>

                <p className="contactRow">
                  <span className="contactDot" aria-hidden="true">✉️</span>
                  <a href="mailto:shynegraphicscorp@gmail.com">
                    shynegraphicscorp@gmail.com
                  </a>
                </p>

                <p className="contactRow muted">
                  <span className="contactDot" aria-hidden="true">🕒</span>
                  Mon–Fri, 9:00 a.m. – 5:00 p.m.
                </p>

                <a
                  className="emailBtn"
                  href="mailto:shynegraphicscorp@gmail.com?subject=Proposal%20Request"
                >
                  Email us directly
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default Contact;